(() => {
  if (window.__callgearLoaded) return;

  var LOAD_DELAY_MS = 15000;
  var loadTimer = null;

  function loadCallgear() {
    if (window.__callgearLoaded) return;
    window.__callgearLoaded = true;
    if (loadTimer) {
      window.clearTimeout(loadTimer);
      loadTimer = null;
    }
    window.removeEventListener('pointerdown', loadCallgear, true);
    window.removeEventListener('touchstart', loadCallgear, true);
    window.removeEventListener('keydown', loadCallgear, true);
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://app.callgear.ae/static/cs.min.js?k=720G0F5ycvu1Z2OLcBYsBL2P8_RLtIKO';
    document.head.appendChild(script);
  }

  function scheduleCallgear() {
    if (loadTimer) return;
    loadTimer = window.setTimeout(loadCallgear, LOAD_DELAY_MS);
  }

  function bindInteractionListeners() {
    window.addEventListener('pointerdown', loadCallgear, { once: true, passive: true, capture: true });
    window.addEventListener('touchstart', loadCallgear, { once: true, passive: true, capture: true });
    window.addEventListener('keydown', loadCallgear, { once: true, capture: true });
    scheduleCallgear();
  }

  if (document.readyState === 'complete') {
    bindInteractionListeners();
    return;
  }

  window.addEventListener('load', bindInteractionListeners, { once: true });
})();
